import { render, staticRenderFns } from "./AreaTransfer.vue?vue&type=template&id=ef2bda7e&scoped=true"
import script from "./AreaTransfer.vue?vue&type=script&lang=js"
export * from "./AreaTransfer.vue?vue&type=script&lang=js"
import style0 from "./AreaTransfer.vue?vue&type=style&index=0&id=ef2bda7e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef2bda7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/opter/repo/code/cloudsee-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef2bda7e')) {
      api.createRecord('ef2bda7e', component.options)
    } else {
      api.reload('ef2bda7e', component.options)
    }
    module.hot.accept("./AreaTransfer.vue?vue&type=template&id=ef2bda7e&scoped=true", function () {
      api.rerender('ef2bda7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel-manager/user/components/AreaTransfer/AreaTransfer.vue"
export default component.exports